// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadingspinner {
  --square: 26px;
  --offset: 30px;
  --duration: 2.4s;
  --delay: 0.2s;
  --timing-function: ease-in-out;
  --in-duration: 0.4s;
  --in-delay: 0.1s;
  --in-timing-function: ease-out;
  width: calc(3 * var(--offset) + var(--square));
  height: calc(2 * var(--offset) + var(--square));
  padding: 0px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  margin-bottom: 30px;
  position: relative;
}

.loadingspinner div {
  display: inline-block;
  background: var(--primary-color);
  /*background: var(--text-color);*/
  /*box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);*/
  border: none;
  border-radius: 2px;
  width: var(--square);
  height: var(--square);
  position: absolute;
  padding: 0px;
  margin: 0px;
  font-size: 6pt;
  color: black;
}

.loadingspinner #square1 {
  left: calc(0 * var(--offset));
  top: calc(0 * var(--offset));
  animation: square1 var(--duration) var(--delay) var(--timing-function)
      infinite,
    squarefadein var(--in-duration) calc(1 * var(--in-delay))
      var(--in-timing-function) both;
}

.loadingspinner #square2 {
  left: calc(0 * var(--offset));
  top: calc(1 * var(--offset));
  animation: square2 var(--duration) var(--delay) var(--timing-function)
      infinite,
    squarefadein var(--in-duration) calc(1 * var(--in-delay))
      var(--in-timing-function) both;
}

.loadingspinner #square3 {
  left: calc(1 * var(--offset));
  top: calc(1 * var(--offset));
  animation: square3 var(--duration) var(--delay) var(--timing-function)
      infinite,
    squarefadein var(--in-duration) calc(2 * var(--in-delay))
      var(--in-timing-function) both;
}

.loadingspinner #square4 {
  left: calc(2 * var(--offset));
  top: calc(1 * var(--offset));
  animation: square4 var(--duration) var(--delay) var(--timing-function)
      infinite,
    squarefadein var(--in-duration) calc(3 * var(--in-delay))
      var(--in-timing-function) both;
}

.loadingspinner #square5 {
  left: calc(3 * var(--offset));
  top: calc(1 * var(--offset));
  animation: square5 var(--duration) var(--delay) var(--timing-function)
      infinite,
    squarefadein var(--in-duration) calc(4 * var(--in-delay))
      var(--in-timing-function) both;
}

@keyframes square1 {
  0% {
    left: calc(0 * var(--offset));
    top: calc(0 * var(--offset));
  }

  8.333% {
    left: calc(0 * var(--offset));
    top: calc(1 * var(--offset));
  }

  100% {
    left: calc(0 * var(--offset));
    top: calc(1 * var(--offset));
  }
}

@keyframes square2 {
  0% {
    left: calc(0 * var(--offset));
    top: calc(1 * var(--offset));
  }

  8.333% {
    left: calc(0 * var(--offset));
    top: calc(2 * var(--offset));
  }

  16.67% {
    left: calc(1 * var(--offset));
    top: calc(2 * var(--offset));
  }

  25.00% {
    left: calc(1 * var(--offset));
    top: calc(1 * var(--offset));
  }

  83.33% {
    left: calc(1 * var(--offset));
    top: calc(1 * var(--offset));
  }

  91.67% {
    left: calc(1 * var(--offset));
    top: calc(0 * var(--offset));
  }

  100% {
    left: calc(0 * var(--offset));
    top: calc(0 * var(--offset));
  }
}

@keyframes square3 {
  0%,
  100% {
    left: calc(1 * var(--offset));
    top: calc(1 * var(--offset));
  }

  16.67% {
    left: calc(1 * var(--offset));
    top: calc(1 * var(--offset));
  }

  25.00% {
    left: calc(1 * var(--offset));
    top: calc(0 * var(--offset));
  }

  33.33% {
    left: calc(2 * var(--offset));
    top: calc(0 * var(--offset));
  }

  41.67% {
    left: calc(2 * var(--offset));
    top: calc(1 * var(--offset));
  }

  66.67% {
    left: calc(2 * var(--offset));
    top: calc(1 * var(--offset));
  }

  75.00% {
    left: calc(2 * var(--offset));
    top: calc(2 * var(--offset));
  }

  83.33% {
    left: calc(1 * var(--offset));
    top: calc(2 * var(--offset));
  }

  91.67% {
    left: calc(1 * var(--offset));
    top: calc(1 * var(--offset));
  }
}

@keyframes square4 {
  0% {
    left: calc(2 * var(--offset));
    top: calc(1 * var(--offset));
  }

  33.33% {
    left: calc(2 * var(--offset));
    top: calc(1 * var(--offset));
  }

  41.67% {
    left: calc(2 * var(--offset));
    top: calc(2 * var(--offset));
  }

  50.00% {
    left: calc(3 * var(--offset));
    top: calc(2 * var(--offset));
  }

  58.33% {
    left: calc(3 * var(--offset));
    top: calc(1 * var(--offset));
  }

  100% {
    left: calc(3 * var(--offset));
    top: calc(1 * var(--offset));
  }
}

@keyframes square5 {
  0% {
    left: calc(3 * var(--offset));
    top: calc(1 * var(--offset));
  }

  50.00% {
    left: calc(3 * var(--offset));
    top: calc(1 * var(--offset));
  }

  58.33% {
    left: calc(3 * var(--offset));
    top: calc(0 * var(--offset));
  }

  66.67% {
    left: calc(2 * var(--offset));
    top: calc(0 * var(--offset));
  }

  75.00% {
    left: calc(2 * var(--offset));
    top: calc(1 * var(--offset));
  }

  100% {
    left: calc(2 * var(--offset));
    top: calc(1 * var(--offset));
  }
}

@keyframes squarefadein {
  0% {
    transform: scale(0.75);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Calendar/assets/scheduler/css/components/loader.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,8CAA8C;EAC9C,+CAA+C;EAC/C,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,iCAAiC;EACjC,8CAA8C;EAC9C,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B;;;oCAGkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B;;;oCAGkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B;;;oCAGkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B;;;oCAGkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B;;;oCAGkC;AACpC;;AAEA;EACE;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;EACE;;IAEE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":[".loadingspinner {\n  --square: 26px;\n  --offset: 30px;\n  --duration: 2.4s;\n  --delay: 0.2s;\n  --timing-function: ease-in-out;\n  --in-duration: 0.4s;\n  --in-delay: 0.1s;\n  --in-timing-function: ease-out;\n  width: calc(3 * var(--offset) + var(--square));\n  height: calc(2 * var(--offset) + var(--square));\n  padding: 0px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 10px;\n  margin-bottom: 30px;\n  position: relative;\n}\n\n.loadingspinner div {\n  display: inline-block;\n  background: var(--primary-color);\n  /*background: var(--text-color);*/\n  /*box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);*/\n  border: none;\n  border-radius: 2px;\n  width: var(--square);\n  height: var(--square);\n  position: absolute;\n  padding: 0px;\n  margin: 0px;\n  font-size: 6pt;\n  color: black;\n}\n\n.loadingspinner #square1 {\n  left: calc(0 * var(--offset));\n  top: calc(0 * var(--offset));\n  animation: square1 var(--duration) var(--delay) var(--timing-function)\n      infinite,\n    squarefadein var(--in-duration) calc(1 * var(--in-delay))\n      var(--in-timing-function) both;\n}\n\n.loadingspinner #square2 {\n  left: calc(0 * var(--offset));\n  top: calc(1 * var(--offset));\n  animation: square2 var(--duration) var(--delay) var(--timing-function)\n      infinite,\n    squarefadein var(--in-duration) calc(1 * var(--in-delay))\n      var(--in-timing-function) both;\n}\n\n.loadingspinner #square3 {\n  left: calc(1 * var(--offset));\n  top: calc(1 * var(--offset));\n  animation: square3 var(--duration) var(--delay) var(--timing-function)\n      infinite,\n    squarefadein var(--in-duration) calc(2 * var(--in-delay))\n      var(--in-timing-function) both;\n}\n\n.loadingspinner #square4 {\n  left: calc(2 * var(--offset));\n  top: calc(1 * var(--offset));\n  animation: square4 var(--duration) var(--delay) var(--timing-function)\n      infinite,\n    squarefadein var(--in-duration) calc(3 * var(--in-delay))\n      var(--in-timing-function) both;\n}\n\n.loadingspinner #square5 {\n  left: calc(3 * var(--offset));\n  top: calc(1 * var(--offset));\n  animation: square5 var(--duration) var(--delay) var(--timing-function)\n      infinite,\n    squarefadein var(--in-duration) calc(4 * var(--in-delay))\n      var(--in-timing-function) both;\n}\n\n@keyframes square1 {\n  0% {\n    left: calc(0 * var(--offset));\n    top: calc(0 * var(--offset));\n  }\n\n  8.333% {\n    left: calc(0 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n\n  100% {\n    left: calc(0 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n}\n\n@keyframes square2 {\n  0% {\n    left: calc(0 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n\n  8.333% {\n    left: calc(0 * var(--offset));\n    top: calc(2 * var(--offset));\n  }\n\n  16.67% {\n    left: calc(1 * var(--offset));\n    top: calc(2 * var(--offset));\n  }\n\n  25.00% {\n    left: calc(1 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n\n  83.33% {\n    left: calc(1 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n\n  91.67% {\n    left: calc(1 * var(--offset));\n    top: calc(0 * var(--offset));\n  }\n\n  100% {\n    left: calc(0 * var(--offset));\n    top: calc(0 * var(--offset));\n  }\n}\n\n@keyframes square3 {\n  0%,\n  100% {\n    left: calc(1 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n\n  16.67% {\n    left: calc(1 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n\n  25.00% {\n    left: calc(1 * var(--offset));\n    top: calc(0 * var(--offset));\n  }\n\n  33.33% {\n    left: calc(2 * var(--offset));\n    top: calc(0 * var(--offset));\n  }\n\n  41.67% {\n    left: calc(2 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n\n  66.67% {\n    left: calc(2 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n\n  75.00% {\n    left: calc(2 * var(--offset));\n    top: calc(2 * var(--offset));\n  }\n\n  83.33% {\n    left: calc(1 * var(--offset));\n    top: calc(2 * var(--offset));\n  }\n\n  91.67% {\n    left: calc(1 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n}\n\n@keyframes square4 {\n  0% {\n    left: calc(2 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n\n  33.33% {\n    left: calc(2 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n\n  41.67% {\n    left: calc(2 * var(--offset));\n    top: calc(2 * var(--offset));\n  }\n\n  50.00% {\n    left: calc(3 * var(--offset));\n    top: calc(2 * var(--offset));\n  }\n\n  58.33% {\n    left: calc(3 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n\n  100% {\n    left: calc(3 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n}\n\n@keyframes square5 {\n  0% {\n    left: calc(3 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n\n  50.00% {\n    left: calc(3 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n\n  58.33% {\n    left: calc(3 * var(--offset));\n    top: calc(0 * var(--offset));\n  }\n\n  66.67% {\n    left: calc(2 * var(--offset));\n    top: calc(0 * var(--offset));\n  }\n\n  75.00% {\n    left: calc(2 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n\n  100% {\n    left: calc(2 * var(--offset));\n    top: calc(1 * var(--offset));\n  }\n}\n\n@keyframes squarefadein {\n  0% {\n    transform: scale(0.75);\n    opacity: 0;\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
